/** Rolle der Plattformverwaltung (Anmeldung über /admin/login). */
export const PLATFORM_ADMIN_ROLE = "PlatformAdmin" as const;
